import { AnchorTreeItem, anchorTreeItemTag } from '@ni/nimble-components/dist/esm/anchor-tree-item';
import { wrap } from '../utilities/react-wrapper';

export { anchorTreeItemTag };
export { type AnchorTreeItem };
export const NimbleAnchorTreeItem = wrap(AnchorTreeItem);
